import styled from 'styled-components/macro'
import { Thread } from 'styles/misc'
import { mq } from 'styles/mq'

export const Threaded = styled.div`
  position: relative;

  ${mq.medium} {
    &::before {
      ${Thread}
      top: 50%;
      width: 100%;
      transform: translateY(-50%);
      aspect-ratio: 2228 / 138;
      mask-image: url("data:image/svg+xml,%3Csvg width='2228' height='138' viewBox='0 0 2228 138' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 71.8414C27.42 118.82 177.191 102.821 286.78 89.6403C427.346 72.7323 561.739 33.5349 700.725 6.59119C724.149 2.04603 748.633 -2.13551 771.601 4.30952C794.569 10.7546 815.428 31.0987 814.24 54.8244C813.053 78.5501 781.492 97.158 763.3 81.7862C755.482 74.814 757.82 61.2149 765.327 53.9063C772.834 46.5976 783.629 43.9705 793.884 41.7434C1024.45 -8.18966 1267.46 -0.0447421 1494.13 65.2146C1577.47 89.213 1659.41 120.938 1745.68 130.038C1846.68 140.691 2127.87 155.545 2226.5 41.0071' stroke='white' vector-effect='non-scaling-stroke' stroke-width='1.5' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");
    }
  }
`

export const Figure = styled.figure`
  margin: 2rem 0 4rem;

  img {
    display: block;
    width: 100%;
    aspect-ratio: 1444 / 1085;
    object-fit: cover;
  }

  figcaption {
    padding-top: 1em;
    font-size: 1.4rem;
    line-height: 1.42;
    text-align: center;
  }

  a {
    display: block;
    margin: 0 auto;
    padding: 0 0.4em;
    text-decoration: underline;
    width: max-content;
    max-width: 100%;
    background: none;
  }
`
